export default __webpack_public_path__ + "locales/lv/InfoPanel.json?hash=93414fe15acf32f36bf243004ef5f90c";